import React from 'react'

import NotApproveProjectMulti from './NotApproveProjectMulti'

export default function NotApproveClosureMulti() {
  return <NotApproveProjectMulti />
}
